import { Form } from 'antd';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useLines } from '@/hooks/v1/useLines';

interface LineProps {
	fieldName?: string | string[];
}

const { useFormInstance, useWatch } = Form;

export function useLine({ fieldName }: LineProps) {
	const form = useFormInstance();
	const { organization, company } = useApplicationContext();

	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const sectorId = useWatch(field ? [field, 'sector_id'] : 'sector_id');
	const lineId = useWatch(field ? [field, 'line_id'] : 'line_id');

	const {
		isFetching,
		data: lines,
		isError
	} = useLines({
		organization_id: organization.id!,
		company_id: company.id!,
		sector_id: sectorId
	});

	const isDisabled = !sectorId;

	function handleSelectLine(id: string): void {
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], id);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], undefined);
	}

	function handleClearLines(): void {
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], undefined);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], undefined);
	}

	const items =
		lines?.map((line: { id: string; name: string }) => ({
			value: line.id,
			label: line.name
		})) || [];

	return {
		items,
		lineId,
		sectorId,
		isFetching,
		isError,
		isDisabled,
		handleSelectLine,
		handleClearLines
	};
}
